import React, { Component } from 'react'
import PageHead from '../../components/pageHead';
import Layout from '../../components/Layout';
import '../../sass/_services-details.scss';
import '../../sass/_home.scss';
import TalkData from '../../components/talk-data';
import { Container, Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import ScrollAnimation from 'react-wow';
import Header from '../../components/header';

export default class index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <Header name="services" />
                <PageHead title="AXLR DATA PVT LTD | Software Solutions"></PageHead>
                <Layout>

                    <div>
                        <section className="animejs-code">
                            <Container>
                                <div className="mt-sm-3 pt-sm-5">
                                    <Row>
                                        <Col className="pr-sm-0" md={7}>
                                            <div className="pl-sm-3 pt-5">
                                                <div className="">
                                                    <div className="count">02</div>
                                                    <div className="talk-content count-sd pl-3">What we do?</div>
                                                </div>
                                                <div className="big-heading pt-2 get-0909">UX/UI Design</div>
                                                <div className="main-content pt-sm-5">Design creates culture. Culture shapes values. Values determine the future.</div>
                                            </div>
                                        </Col>
                                        <Col className="text-center">
                                            <video className="width-vedio" autoPlay loop playsInline muted>
                                            <source src={`${publicRuntimeConfig.staticFolder}/images/svg-vedio.mp4`} type="video/mp4" />
                                            </video>
                                        </Col>
                                    </Row>
                                </div>
                                <br />
                                <br />
                            </Container>
                        </section>

                        <section className="" id="User-Research">
                            <Container className="pt-sm-5">
                                <Row>
                                    <Col className="text-center">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/dev-group.png`} alt="dev-group" className="w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">User Research</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-12" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                        One of the founding pillars of UX/UI, we conduct thorough user research to understand users’
                                         characteristics, aims, and approaches to reach these aims. We employ observational and experimental 
                                         methodologies to create user personas and fully understand the context of use.<span class="read-more-target"> This aids in producing
                                          designs truly relevant to the users and are easy and pleasurable for them to use</span>
                                                </div>
                                        <label for="post-12" class="read-more-trigger"></label>     
                                        </div>
                                        
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Data Integration</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">User Personas</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Online Surveys/Polls</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Contextual Observations</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Interviews</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Field Studies</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Moderated Usability Testing</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="User-Experience-Design">
                            <Container className="mt-sm-5 pt-sm-5">
                                <Row>
                                <Col className="text-center mobile">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <div className="spectial-content pt-2 mt-5 ta9990pj">We don't make users</div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/ezgif.com-gif-maker.gif`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">User Experience Design</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-88" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                        A process that we use to design a set of meaningful, relevant and cohesive experiences 
                                        to the end-users. With the end-user at the center, we define the Why, What and How of 
                                        the product in the form of a UX guideline. This forms the basis <span class="read-more-target">for user requirements 
                                        and aids in creating high fidelity design solutions that fit to the user’s 
                                        untold requirements</span>
                                                </div>
                                        <label for="post-88" class="read-more-trigger"></label>     
                                        </div>
                                        
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">User Personas</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">UX Guideline</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">User Journeys</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Wireframing</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Prototyping</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Moderated Usability Testing</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    <Col className="text-center desktop">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <div className="spectial-content pt-sm-2 mt-sm-5 ta9990pj">We don't make users</div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/ezgif.com-gif-maker.gif`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="User-Interface-Design">
                            <Container className="mt-5 pt-5">
                                <Row>
                                    <Col className="text-center">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/dev-group.png`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">User Interface Design</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-13" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                        Guided by the UX and the brand guidelines, we design visual interfaces that strike 
                                        a beautiful balance between technical functionality and visual elements. 
                                        All this while maintaining high discoverability, highlighting key features,<span class="read-more-target"> 
                                        minimizing user actions and producing burden-free user navigation</span>
                                                </div>
                                        <label for="post-13" class="read-more-trigger"></label>     
                                        </div>
                                        
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Visual Design Interfaces</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Web Design</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">App Interfaces</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">A/B Testing</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Illustrations</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Mockups</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="Customer-Journey-Mapping">
                            <Container className="mt-5 pt-5">
                                <Row>
                                <Col className="text-center mobile">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                {/* <div className="spectial-content pt-sm-5 mt-sm-5 ta9990pj">We don't make users</div> */}
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/dev-group.png`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">Customer Journey Mapping</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-14" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                        Understanding a customer's journey provides deep insights into pain points, 
                                        feelings, and moments of delight for a customer. We work with you to understand 
                                        customer touchpoints, how they respond, make decisions and what influences 
                                        <span class="read-more-target"> them in order to refine how and when a customer interacts with your brand. 
                                        We derive insights from a customer's journey to build seamless and delightful 
                                        customer experience</span>
                                                </div>
                                        <label for="post-14" class="read-more-trigger"></label>     
                                        </div>
                                        
                                        <div className="pt-4">
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Customer Lifecycle</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Pain point Analysis</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">TouchPoint Effectiveness</div>
                                                </Col>
                                            </Row>

                                        </div>
                                    </Col>
                                    <Col className="text-center desktop">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                {/* <div className="spectial-content pt-sm-5 mt-sm-5 ta9990pj">We don't make users</div> */}
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/dev-group.png`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <TalkData title={<span>Got some data?<br /> Let us churn!</span>} subtitle="" />
                    </div>

                </Layout>
                <style>
                    {`
                    body{
                        overflow-x: hidden
                    }
                    .ta9990pj{
                        font-size: 30px !important;
                        font-weight: 900;
                    }
                    @media only screen and (max-width: 768px){
                        .big-heading {
                            font-size: 60px !important;
                            line-height: 75px !important;
                            padding-bottom: 25px;
                            padding-top: 35px !important;
                        }
                    }
                    `}
                </style>
            </div>
        )
    }
}